import styled from 'styled-components'
import { Container } from 'src/components/common/Container'
import { NavLink } from 'react-router-dom'
import { Noto_body1_m16 } from 'src/styles/fonts/NotoSansKrFonts'
import { Icon } from 'src/assets/svg/Icon'
import usePageNav from 'src/hooks/usePageNav.hook'

const TermsPageView = () => {
  const { addUtmParameter } = usePageNav()
  return (
    <S.TermsContainer $option="flex_column">
      <S.TermsNavLink to={addUtmParameter('/help_center/terms/service')}>
        서비스 이용약관
        <Icon.Arrow size="16" rotate="right" color="var(--black-50)" />
      </S.TermsNavLink>
      <S.TermsNavLink to={addUtmParameter('/help_center/terms/privacy_policy')}>
        개인정보처리방침
        <Icon.Arrow size="16" rotate="right" color="var(--black-50)" />
      </S.TermsNavLink>
      {/* <S.TermsNavLink to={addUtmParameter('/help_center/terms/marketing')}>
        마케팅 정보 수신 동의
        <Icon.Arrow size="16" rotate="right" color="var(--black-50)" />
      </S.TermsNavLink> */}
      <S.TermsNavLink to={addUtmParameter('/help_center/terms/business')}>
        사업자 정보
        <Icon.Arrow size="16" rotate="right" color="var(--black-50)" />
      </S.TermsNavLink>
    </S.TermsContainer>
  )
}

export default TermsPageView

const S = {
  TermsContainer: styled(Container)`
    width: 100%;
    display: flex;
    flex: 1;
    padding-top: 20px;
  `,
  TermsNavLink: styled(NavLink)`
    ${Noto_body1_m16};
    background-color: var(--white);
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    position: relative;
    cursor: pointer;
    width: 100%;
    padding: 12px 20px;
  `,
}
